import React, { useEffect, useState } from "react";
import logo from '../leclab-madrid-vertical.png';
import { useNavigate } from "react-router-dom";
import { auth, getUserInfo, logInWithEmailAndPassword, logout, signInWithGoogle } from "../services/firebase/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import '../index.css'
import { useAuth } from "../context/AuthContext";

function Login() {

    const [email, setEmail] = useState({ value: '', error: '' });
    const [password, setPassword] = useState({ value: '', error: '' });
    const [user, loading, error] = useAuthState(auth);
    const [submitLoading, setSubmitLoading] = useState(false)
    const { setCurrentUser, login } = useAuth()
    const navigate = useNavigate();


    const emailValidation = (email) => {
        // TODO: Create email validator
        setEmail({ ...email, error: 'Email no válido' })
    }

    const passwordValidation = () => {
        setPassword({ ...password, error: 'Debe contener al menos 8 caracteres' })
    }

    const doLogin = (e) => {
        e.preventDefault()
        if (!email.value | !password.value) return
        setSubmitLoading(true)
        login(email.value, password.value)
            .then((loggedInUser) => {
                setCurrentUser(loggedInUser)
            }).catch(e => {
                alert("Los datos con los que intenta acceder a su cuenta no son correctos")
            })
            .finally(() => setSubmitLoading(false))
    }

    useEffect(() => {
        if (loading) {
            // TODO: Set loading state
            return;
        }
        if (user) {
            getUserInfo(user.uid).then(info => {
                if (info?.isAdmin) {
                    setSubmitLoading(false)
                    navigate('/admin')
                    return;
                } else {
                    navigate('/user')
                    setSubmitLoading(false)
                    return
                }

            })
        }
    }, [user, loading]);

    return (
        <div className="auth-wrapper">
            <div className="auth-inner">
                <div className="card-header bg-transparent">
                    <img alt="Leclab Madrid" width="300" src={logo} />
                </div>
                <div className="card-body">
                    <form >
                        <div className="form-group d-block">
                            <div className="mb-3">
                                <input type="email" className="form-control" placeholder="Correo electrónico" value={email.value} onChange={(e) => setEmail({ ...email, value: e.target.value })} />
                                <p className="mt-1 text-danger">{email.error && email.error}</p>
                            </div>
                            <div className="mb-3">
                                <input type="password" className="form-control" placeholder="Contraseña" value={password.value} onChange={e => setPassword({ ...password, value: e.target.value })} />
                            </div>
                        </div>
                        {!submitLoading && <button type="submit" className="btn btn-login btn-block w-100" onClick={doLogin}>Acceder</button>}
                        {submitLoading &&
                            <button className="btn btn-login btn-block w-100" type="button" disabled>
                                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                Loading...
                            </button>
                        }
                    </form>
                    <div className="d-flex justify-content-between align-items-center">
                        <p className="forgot-password text-right">
                            No recuerdo mi <a href="/recover-pass">contraseña</a>
                        </p>
                        <p className="forgot-password text-right">
                            <a href="/application">Quiero ser Socio</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;